import CRUD from './crud'

export default new CRUD('tournament-judge-messages', 'superior-judge')
